import styled from 'styled-components';

export const Container = styled.a`
  .optionMenuNavBar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme }) => theme.colors.background_white};
    text-decoration: none;
    background: transparent;
    border: none;
    font-family: 'Futura PT';
    font-size: 1.3rem;
    font-weight: 300;
    padding: 0;
    svg {
      fill: ${({ theme }) => theme.colors.background_white};
      font-size: 1.3rem;
      max-width: 1.3rem;
      min-width: 1.3rem;
      max-height: 1.3rem;
      min-height: 1.3rem;
    }

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.colors.yellow_200};
      fill: ${({ theme }) => theme.colors.yellow_200};
    }
  }
`;
